<template>
  <div class="TuanSuccess">
    <div class="title van-hairline--bottom">
      <p class="text-bold">
        <van-tag class="tuantag">{{theItem.ctUserNum}}人团</van-tag>
        <span>{{theItem.title}}</span>
        <span class="price">¥{{theItem.price/ 100}}</span>
      </p>
    </div>
    <div class="imgbox">
      <div v-for="(i,index) in theItem.userOrderList" :key="i.id">
        <span class="posre m20" v-if="index === 0">
          <img class="img" :src="i.headimgurl" mode="scaleToFill" />
          <div class="bk-G4" />
        </span>
        <img class="img m20" v-else :src="i.headimgurl" mode="scaleToFill" />
      </div>
      <img
        class="img m20"
        v-for="(v,index) in num"
        :key="index"
        :src="require('@/assets/images/icon/space.png')"
        mode="scaleToFill"
      />
    </div>
    <div class="btn" v-if="theItem.ctUserNum !== len">
      <van-button type="primary" @click="goPay(1)">
        邀请好友拼单
        <timeCounter :end="theItem.ptExpireTime"></timeCounter>&nbsp;后结束
      </van-button>
      <p>分享到3个群，有很大机率5分钟内成团~</p>
    </div>
    <div class="btn" v-else>
      <van-button type="primary" @click="goPay(2)">查看我的订单</van-button>
    </div>

    <div v-if="list && theItem.ctUserNum === len" class="mt50">
      <div class="more">
        <div class="title">
          领取更多权益
          <span>也可在订单详情中领取哦~</span>
        </div>
        <div class="fbox" v-for="v in list" :key="v.id">
          <span>{{v.cardName}}</span>
          <a :href="v.cardUrl">
            <van-button>去领取</van-button>
          </a>
          <!-- <van-button @click="location.href=v.cardUrl">领取</van-button> -->
        </div>
      </div>
    </div>
    <!-- <div class="list">
      <template v-for="(it, i) in theItem.userOrderList">
        <div :key="i" class="leader" v-if="i===0">
          <img
            :src="it.headimgurl||'http://study-centre.oss-cn-hangzhou.aliyuncs.com/oajgcamvg_1567576133404.png'"
          />
          <div class="name">团长</div>
        </div>
        <img
          :key="i"
          :src="it.headimgurl||'http://study-centre.oss-cn-hangzhou.aliyuncs.com/oajgcamvg_1567576133404.png'"
          alt
          v-else
        />
      </template>
      <img
        v-for="(y,j) in (theItem.teamNum - theItem.headImgList.length)"
        :src="require('@/assets/images/icon/space.png')"
        :key="'d'+j"
      />
    </div>-->

    <!-- <div class="btn" v-if="theItem.headImgList.length===theItem.teamNum">
      <p>拼单成功~</p>
      <van-button class="checkorder" size="small">查看我的订单</van-button>
    </div>
    <div class="btn" v-else-if="!tuanIsFinished()">
      <van-button type="primary" @click="show=true">
        邀请好友拼单
        <timeCounterSinple :end="theItem.endTime"></timeCounterSinple>&nbsp;后结束
      </van-button>
      <p>分享到3个群，有很大几率5分钟内成团</p>
    </div>
    <div class="btn" v-if="tuanIsFinished()">
      <p>拼单失败了，支付金额已退还</p>
      <h3>拼团结束</h3>
    </div>

    <van-popup class="share" v-model="show" @click="show=false">
      <img :src="require('@/assets/images/common/wx.png')" v-if="wx===1" alt />
      <img :src="require('@/assets/images/common/pyq.png')" v-if="wx===2" alt />
    </van-popup>-->
  </div>
</template>
<script>
import timeCounter from "@/components/timeCounter1";
// import timeCounterSinple from "@/components/timeCounterSinple";
export default {
  name: "TuanSuccess",
  components: { timeCounter },
  data () {
    return {
      ActiveShowForm: {
        // content: require('@/assets/images/common/banner.png'),
        name: "杭州教育艺术培训中心",
        title: "暑假班拼团，送福利！课程拼团仅需100元，大福利就来了",
        endTime: "2019-06-20",
        className: "",
        classDesc: "",
        classImg: [],
        originPrice: "688",
        groupPrice: "100",
        teamNum: "3",
        topNum: "20",
        activeDesc: "",
        rewardDesc: "",
        QrImg: [],
        ruleText: "",
        ruleImg: [],
        ruleVideo: [],
        phone: "",
        regList: [1, 2],
        eventName: "团购抢好课"
      },
      theItem: {},
      num: '',
      show: false,
      list: [],
      wx: 1,
      len: 0
    };
  },
  watch: {},
  computed: {},
  created () { },
  mounted () {
    this.getJoinTeam();
    this.getRight();
    // this.getList();
    // if (this.$route.query.id) {
    //   this.getActiveShowForm();
    // }
    // if (this.$route.query.joinId) {
    //   this.getJoinTeam();
    // }
    // /activity/lesson/getJoinTeam
  },
  methods: {
    goPay (type) {
      let tuanId = this.getStore('tuanId') ? this.getStore('tuanId') : '';
      this.removeStore('tuan');
      this.removeStore('tuanId');
      if (type === 1) {
        // this.setStore('To', 'Tuan');
        // this.go(`/personalcenter?to=Tuan&id=${this.$route.query.activityId}&tuanId=${tuanId}&showHelp=true`);
        // this.go(`/Activity/Tuan?id=${this.$route.query.activityId}&tuanId=${tuanId}&showHelp=true`);
        this.go(`/Activity/Tuan?id=${this.$route.query.activityId}&tuanId=${tuanId}&showHelp=true`);
      } else {
        this.setStore('To', 'order');
        this.go('/personalcenter?to=order');
        // this.go(`/order`);
      }
    },
    tuanIsFinished () {
      if (this.theItem.endTime) {
        const time = new Date().getTime();
        if (time >= this.theItem.endTime) {
          return true;
        }
        return false;
      }
      return false;
    },
    async getRight () {
      try {
        let res = await this.$store.dispatch('postData', {
          url: 'activity/activity/userActivityGet',
          data: {
            id: this.$route.query.activityId
          }
        });

        console.log(res);
        if (res.data) {
          this.list = res.data.activityRightsList ? res.data.activityRightsList : [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    getList (query) {
      if (query) this.queryData = { ...this.queryData, ...query };
      this.dataList.currentPage = 1;
      this.dataList.empty = 0;
      this.dataList.finished = false;
      this.Search();
    },
    // async getActiveShowForm() {
    //   try {
    //     this.loading = true;
    //     let result = await this.$store.dispatch("getData", {
    //       url: "/activity/lesson/getTeamActivity",
    //       data: this.$route.query,
    //       urltitle: "/show"
    //     });
    //     // console.log(this.dataCheckList);
    //     this.ActiveShowForm = result;
    //   } catch (e) {
    //     this.$error(e.message);
    //   }
    // },
    async getJoinTeam () {
      try {
        this.loading = true;
        let result = await this.$store.dispatch("postData", {
          url: "/activity/activity/getTeamInfo",
          data: {
            id: this.getStore('tuanId')
          }
        });
        // console.log(this.dataCheckList);
        let reg = /-/g;
        this.theItem = {
          ...result.data,
          ptExpireTime: result.data.ptExpireTime.replace(reg, '/')
        };
        if (this.theItem.userOrderList) {
          this.num = this.theItem.ctUserNum - this.theItem.userOrderList.length;
          this.len = this.theItem.userOrderList.length;
        } else {
          this.num = this.theItem.ctUserNum;
        }
        console.log(this.theItem);
      } catch (e) {
        this.$error(e.message);
      }
    }
  }
};
</script>
<style lang="less" scoped>
.TuanSuccess {
  background: #fff;
  .van-popup {
    background: transparent;
  }
  .van-popup.share {
    width: 100vw;
    height: 100vh;
    img {
      width: 319px;
      margin: 17px 0 0 30px;
    }
  }
  .title {
    padding: 0 15px;
    .text-bold {
      font-size: 16px;
      padding: 15px 0;
      .price {
        float: right;
        font-size: 15px;
        margin-top: 2px;
        color: #ff8939;
      }
      .tuantag {
        background: #ff8939;
      }
    }
  }
  .list {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 80px;
    .leader {
      margin-right: 42px;
      padding: 3px;
      position: relative;
      border: 1px solid rgba(0, 150, 255, 1);
      width: 40px;
      height: 40px;

      border-radius: 40px;
      .name {
        position: absolute;
        bottom: -8px;
        left: 2px;
        width: 40px;
        height: 16px;
        background: rgba(255, 255, 255, 1);
        border-radius: 2px;
        border: 1px solid rgba(0, 150, 255, 1);
        text-align: center;
        font-size: 12px;
        color: rgba(0, 150, 255, 1);
      }
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 40px;
      &:not(:last-child) {
        margin-right: 41px;
      }
    }
  }
  .btn {
    margin: 30px auto 10px;
    text-align: center;
    .van-button {
      width: 300px;
    }
    .checkorder {
      width: 2.59rem;
    }
    p {
      font-size: 12px;
      margin-top: 10px;
      padding-bottom: 20px;
    }
    h3 {
      font-size: 14px;
      font-weight: bold;
      padding-bottom: 20px;
    }
  }
}

.imgbox {
  display: flex;
  height: 60px;
  line-height: 60px;
  margin: 25px 0;
  div {
    width: 100%;
    text-align: center;
    flex: 1;
    width: 48px;
    img {
      margin-top: 2px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
  .posre {
    position: relative;
    .bk-G4 {
      position: absolute;
      left: -4px;
      width: 48px;
      height: 90px;
      top: -31px;
      background: url("~@/assets/images/icon/Group4.png") no-repeat;
      background-position: center;
      background-size: 48px 53px;
    }
  }
}
.m20 {
  margin: 0 20px;
}

.img {
  position: relative;
  top: 21px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.btn {
  width: 100%;
  height: 50px;
  button {
    width: 100%;
    border: none;
    background-color: #0096ff;
    color: #fff;
    font-size: 15px;
    text-align: center;
    height: 40px;
    line-height: 40px;
  }
  button::after {
    border: none;
  }
}
.fs14 {
  margin-top: 10px;
  font-size: 12px;
  color: #333333;
  text-align: center;
}
.more {
  margin: 5px;
  .title {
    font-size: 14px;
    margin-bottom: 10px;
    span {
      float: right;
      color: #ff8939;
    }
  }
  .fbox {
    display: flex;
    padding: 15px;
    border: 1px solid #f7f7f7;
    span {
      flex: 1;
      line-height: 30px;
      font-size: 14px;
    }
    .van-button {
      width: 80px;
      height: 30px;
      border-radius: 5px;
    }
  }
  .fbox-1 {
    display: flex;
    padding: 15px;
    border-bottom: 2px solid #f7f7f7;
    span {
      font-size: 14px;
      div {
        margin: 5px 0;
      }
    }
    .right {
      flex: 1;
      text-align: right;
    }
    .blue {
      color: #0096ff;
    }
  }
}
.mt50 {
  margin-top: 50px;
}
</style>
